import { states } from '@/constants/lifecycle';
import { openCohort } from '../../state/state';

const openSystemCohort = (requestCode, cohortCode, readStatus = states.PENDING) => {
  const {
    copy,
    ...cohort
  } = openCohort(cohortCode, false, readStatus);
  cohort.requestCode = requestCode;

  return cohort;
};

export default openSystemCohort;
